/**
 * @flow
 * @relayHash 54dc372b1c11bf113df6cde3da7b6a9a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type zipCodeQueryVariables = {|
  trackingKey: string,
  postalCode?: ?string,
  companySecretId?: ?string,
|};
export type zipCodeQueryResponse = {|
  +packageTracker: ?{|
    +packageInfo: ?{|
      +companyHash: ?string
    |}
  |}
|};
export type zipCodeQuery = {|
  variables: zipCodeQueryVariables,
  response: zipCodeQueryResponse,
|};
*/

/*
query zipCodeQuery(
  $trackingKey: String!
  $postalCode: String
  $companySecretId: String
) {
  packageTracker(trackingKey: $trackingKey, postalCode: $postalCode, companySecretId: $companySecretId) {
    packageInfo {
      companyHash
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'trackingKey',
        type: 'String!',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'postalCode',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'companySecretId',
        type: 'String',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTracker',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'companySecretId',
            variableName: 'companySecretId'
          },
          {
            kind: 'Variable',
            name: 'postalCode',
            variableName: 'postalCode'
          },
          {
            kind: 'Variable',
            name: 'trackingKey',
            variableName: 'trackingKey'
          }
        ],
        concreteType: 'TrackerResultNode',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'packageInfo',
            storageKey: null,
            args: null,
            concreteType: 'TrackerPackageInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'companyHash',
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'zipCodeQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'zipCodeQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'zipCodeQuery',
      id: null,
      text:
        'query zipCodeQuery(\n  $trackingKey: String!\n  $postalCode: String\n  $companySecretId: String\n) {\n  packageTracker(trackingKey: $trackingKey, postalCode: $postalCode, companySecretId: $companySecretId) {\n    packageInfo {\n      companyHash\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'fb9b86706991ead6d7c4535fe9cf23c4';
module.exports = node;
